function loadScript() {
  // <!-- Nextop LiveChat {literal} -->
  (function(d,w,c){w.NextopLiveChatID='LIVECHAT:1758792152404:730567888522641408';w[c]=w[c]||function(){(w[c].q=w[c].q||[]).push(arguments)};var s=d.createElement('script');s.async=true;s.src='https://livechat.nextop.com/nextop-im-sdk.min.js';if(d.head)d.head.appendChild(s)})(document,window,'NextopLiveChat');
  // <!-- / Nextop LiveChat {/literal} -->

  window.removeEventListener('scroll', loadScript);
}
window.addEventListener('scroll', loadScript);